module.exports = __webpack_public_path__ + "static/media/navBar_closedLogo.a3efb24d.svg";